<div class="d-flex flex-grow-1 flex-column justify-content-center align-items-center px-3 text-center">
  <p class="display-2 mb-2">Erro 404</p>
  <p class="display-6 text-body-secondary mb-4">Página não encontrada</p>
  <a routerLink="/" class="btn btn-success">Página Inicial</a>
</div>
